<template>
  <v-dialog v-model="dialog" width="800" :persistent="true">
    <template v-slot:activator="{ on }">
      <v-btn color="primary" v-on="on">
        {{ 'app.products_weights.add_product_weight' | trans }}
      </v-btn>
    </template>
    <v-card>
      <v-toolbar card dark color="primary">
        <v-toolbar-title>
          {{
            (!!productWeightId ? 'app.products_weights.edit_product_weight' : 'app.products_weights.add_product_weight') | trans
          }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark small @click="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout wrap align-center>
              <v-flex xs6>
                <v-text-field
                    :label="'app.name' | trans"
                    required
                    v-model="productWeight.name"
                    :rules="rules.name"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="close">
          {{ 'app.close' | trans }}
        </v-btn>
        <v-btn color="primary" @click="save" :disabled="!valid"
               :loading="loading">
          {{ 'app.save' | trans }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import RulesBuilder from "../utils/rulesBuilder";
import {trans} from "../app";

export default {
  data: function () {
    return {
      rulesBuilder: null,
      dialog: false,
      valid: false,
      loading: false,
      productWeightId: null,
      productWeight: {
        name: '',
      },
    }
  },
  props: {
    currentProductWeight: Object,
  },
  created() {
    this.rulesBuilder = new RulesBuilder();
  },
  computed: {
    rules() {
      return {
        name: this.rulesBuilder.addRequiredRule(trans('app.name'))
            .addMaxLengthRule(trans('app.name'), 255)
            .getRules(),
        type: this.rulesBuilder.addRequiredRule(trans('app.type'))
            .getRules(),
      }
    }
  },
  watch: {
    currentProductWeight: function (productWeight) {
      if (productWeight === null) {
        this.productWeightId = null;
        this.productWeight.name = '';
      } else {
        this.productWeightId = productWeight.id;
        this.productWeight.name = productWeight.name
      }
    }
  },
  methods: {
    open: function () {
      this.$refs.form.reset();
      this.productWeightId = null;
      this.dialog = true;
    },
    close: function () {
      this.dialog = false;
      this.$refs.form.reset();
      this.$emit('product_weight_closed');
    },
    save: async function () {
      if (this.$refs.form.validate() === false) {
        return;
      }

      this.loading = true;
      if (this.productWeightId === null) {
        try {
          await axios.post('/v2/products-weights', this.productWeight);
          this.$toast.success(trans('app.saved'));
        } catch (e) {
          this.$toast.error(trans('app.save_failed'));
          this.loading = false;
          return;
        }
      } else {
        const productWeightId = this.productWeightId;
        try {
          await axios.patch(`/v2/products-weights/${productWeightId}`, this.productWeight);
          this.$toast.success(trans('app.saved'));
        } catch (e) {
          this.$toast.error(trans('app.save_failed'));
          this.loading = false;
          return;
        }
      }
      this.$emit('product_weight_stored');
      this.close();
      this.loading = false;
    },
  }
}
</script>
